

























































































import BaseItemsPage from "../BaseItemsPage";
import { PushHistoryItem } from "@/store/push/statistic/types";
import { Component } from "vue-property-decorator";
import PushHistoryFilter from "@/components/Push/Statistic/PushHistoryFilter.vue";
import {ScrollButton} from "wings-ui-components";
import { Getter } from "vuex-class";
import { onlyDateFilter } from "@/utils/date-util";
import { dynamicSort } from "@/utils/data-helper";
import {cloneDeep} from "lodash";

@Component({
  components: {PushHistoryFilter, ScrollButton},
  filters: {onlyDateFilter},
})
export default class PushHistory extends BaseItemsPage<PushHistoryItem> {
  @Getter("pushHistories") responseItems: any;
  is_show_filter = true;
  filterClone: any = {};
  runFilter: boolean = false;
  currentSort:string= "date";
  currentSortOrder:string= "asc";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'date', 'application', 'os', 'os_version', 'subscribed', 'unsubscribed'
    ];
  }

  getData() {
    return this.responseItems;
  }

  get chartsData() {
    return cloneDeep(this.responseItems).sort(dynamicSort('date','desc'));
  }

  setFilter(field: string, value: any) {
    this.filterClone[field] = value;
    this.runFilter = true;
  }
}
